import { ComponentProps } from 'react';
import AntdSpin from 'antd/es/spin';

export default function Spin(props: ComponentProps<typeof AntdSpin>) {
    return <AntdSpin {...props}>{props.children}</AntdSpin>;
}
